module.exports = __webpack_public_path__ + "6245ded7585e1219b8e0d4cd4bc2185a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notifications/megaphone-phone-pencil-sticky.svg
// module id = 2095
// module chunks = 4